import { jsx, jsxs } from "react/jsx-runtime";
import { Button, Stack, Typography } from "@mui/material";
import { useTexts } from "./useTexts.js";
function CompanyKey(props) {
  const { companyKey, onNotYourCompanyKeyClick } = props;
  const texts = useTexts();
  const label = typeof texts.label === "function" ? texts.label(companyKey) : companyKey;
  const handleClick = () => onNotYourCompanyKeyClick?.(companyKey);
  return /* @__PURE__ */ jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", gap: 2, children: [
    /* @__PURE__ */ jsx(Typography, { noWrap: true, sx: { minWidth: 0 }, children: label }),
    onNotYourCompanyKeyClick && /* @__PURE__ */ jsx(Button, { onClick: handleClick, children: texts.notYourCompanyKey })
  ] });
}
export {
  CompanyKey
};
//# sourceMappingURL=CompanyKey.js.map
